export const supabaseUrl: string | undefined = process.env.NEXT_PUBLIC_SUPABASE_URL || "";
export const supabasePublishableKey: string | undefined = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY || "";
export const supabaseSecretKey: string | undefined = process.env.SUPABASE_SECRET_KEY || "";
